
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"26","viewBox":"0 0 24 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.536 2.567h-1.284V0h-2.566v2.567H6.418V0H3.85v2.567H2.567A2.555 2.555 0 00.013 5.134L0 23.103a2.566 2.566 0 002.567 2.567h17.969a2.566 2.566 0 002.567-2.567V5.134a2.566 2.566 0 00-2.567-2.567zm0 20.536H2.567V8.984h17.969v14.119z","fill":"#2C2C2C"}}),_c('path',{attrs:{"d":"M11.55 17.404l-3.13 3.132-1.361-1.361 3.131-3.132-3.131-3.131 1.36-1.36 3.132 3.13 3.132-3.13 1.36 1.36-3.132 3.131 3.132 3.132-1.36 1.36-3.132-3.131z","fill":"#2C2C2C"}})])
          )
        }
      }
    